module.exports = __webpack_public_path__ + "img/robot-1.649b1f5f.png";